import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  max-width: 360px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--background, #fff);
`;

export const Header = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: var(--background-gradient-primary);
  padding: 0 24px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--divisor-message, #cccccc);
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  width: 100%;
  box-sizing: border-box;
  background: var(--background, #fff);
`;

export const ButtonRow = styled.div`
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 0 24px;
`; 